"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApLoaderDefault = void 0;
var React = require("react");
var types_1 = require("../../utils/types");
var styles_1 = require("./styles");
exports.ApLoaderDefault = function (_a) {
    var className = _a.className, loaderSize = _a.loaderSize, loaderText = _a.loaderText, theme = _a.theme;
    return (React.createElement(styles_1.StyledLoaderWrapper, { className: "ap-loader-default " + (className ? className : '') },
        React.createElement(styles_1.StyledLoaderDefault, { theme: theme, loaderSize: loaderSize }),
        loaderText && (React.createElement(styles_1.StyledLoaderTextProp, null, loaderText()))));
};
exports.ApLoaderDefault.defaultProps = {
    loaderSize: 'lg',
    theme: types_1.LIGHT
};
//# sourceMappingURL=ApLoaderDefault.js.map